import { useLayoutEffect, useRef, type ReactNode } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Footer from '../Footer/Footer';
import Header from '../Header/Header';

/**
 * The site shell. `globals.css` pins the app to a fixed, non-scrolling viewport, so this element
 * is the page's scroll region. The header stays put above it and the footer scrolls with the
 * content inside it.
 */
const MainLayout = (): ReactNode => {
  const { pathname } = useLocation();
  const scrollRegion = useRef<HTMLDivElement>(null);

  // Only the routed page below swaps on navigation: this element stays mounted and would keep
  // the offset the previous page was left at, dropping the new page mid-content. Reset it
  // before paint so every page starts at the top. Keyed on the path alone, so in-page anchor
  // links (which only touch the hash) still scroll where they point.
  useLayoutEffect(() => {
    if (scrollRegion.current) {
      scrollRegion.current.scrollTop = 0;
    }
  }, [pathname]);

  return (
    <>
      <Header />
      <div ref={scrollRegion} className="flex flex-1 flex-col overflow-x-hidden overflow-y-auto">
        <Outlet />
        <Footer />
      </div>
    </>
  );
};

export default MainLayout;
